<script setup lang="ts">
/** types */
import type { TEventHero } from '~/src/types/events'

/** constants */
import {
  EVENT_MODALITY,
  EVENT_PREVIEW_CARD_FALLBACK_IMAGE,
} from '~/src/constants/events'

/** components */
import Button from '~/components/common/Button.vue'
import Carousel from '~/components/market-insights/Carousel.vue'
import NavigationLink from '~/components/shared/navigation/Link.vue'
const InPersonIcon = defineAsyncComponent(
  () => import('~/assets/icons/in-person.svg'),
)

/** props */
const props = withDefaults(
  defineProps<{
    events?: TEventHero[]
  }>(),
  {
    events: () => [],
  },
)

/** methods */
const getNavigationTypeElement = (event: TEventHero) => {
  return event.modality !== EVENT_MODALITY.ONLINE ? 'a' : 'nuxt-link'
}

const getEventUrl = (event: TEventHero) => {
  if (event?.url) return event.url
  return event.slug ? `/events/${event.slug}` : ''
}

const getBackgroundFallback = (event: TEventHero) => {
  return event.modality === EVENT_MODALITY.ONLINE
    ? EVENT_PREVIEW_CARD_FALLBACK_IMAGE.ONLINE
    : EVENT_PREVIEW_CARD_FALLBACK_IMAGE.DEFAULT
}

const adaptedEvents = computed(() =>
  props.events.map((event) => ({
    ...event,
    backgroundImage: event.backgroundImage || getBackgroundFallback(event),
  })),
)
</script>
<template>
  <Carousel
    data-testid="carousel-event"
    :items="adaptedEvents"
    item-class="!p-4 md:!p-6"
  >
    <template #content>
      <span
        class="flex size-8 items-center justify-center rounded-lg bg-black p-1 text-p-500"
      >
        <InPersonIcon data-testid="carousel-event-icon" class="w-5" />
      </span>
    </template>
    <template #action="{ item }">
      <NavigationLink
        data-testid="carousel-event-button"
        :url="getEventUrl(item)"
        :type="getNavigationTypeElement(item)"
      >
        <Button variant="clean" class="text-sm"> Learn More </Button>
      </NavigationLink>
    </template>
  </Carousel>
</template>
